// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { resolveProductMinimumOrderQuantity } from "@store/Framework/Common/Utilities/productLineUtilities";
import ProductLeadTime, { ProductLeadTimePresentationProps } from "@store/Library/Components/ProductLeadTime";
import ProductLineMinimumOrderQuantity, {
    ProductLineMinimumOrderQuantityPresentationProps,
} from "@store/Library/Components/ProductLine/ProductLineMinimumOrderQuantity";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface ProductDetailsLeadTimeProps extends WidgetProps {}

export interface ProductDetailsLeadTimeStyles {
    wrapper?: InjectableCss;
    productLeadTime?: ProductLeadTimePresentationProps;
    minimumOrderQuantity?: ProductLineMinimumOrderQuantityPresentationProps;
}

export const productDetailsLeadTimeStyles: ProductDetailsLeadTimeStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: ${pxToRem(8)};
        `,
    },
};

const styles = productDetailsLeadTimeStyles;

const ProductDetailsLeadTime: FC<ProductDetailsLeadTimeProps> = () => {
    const { product, productInfo } = useContext(ProductContext);

    return (
        <StyledWrapper {...styles.wrapper}>
            <ProductLeadTime {...styles.productLeadTime} />
            <ProductLineMinimumOrderQuantity
                {...styles.minimumOrderQuantity}
                minimumOrderQuantity={resolveProductMinimumOrderQuantity(product, productInfo)}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsLeadTime,
    definition: {
        group: "Product Details",
        displayName: "Product Details Lead Time",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
